export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/MaterialIcons-Regular.83bebaf3.woff";